// PrivacyPolicy.jsx
import React from 'react';
import './styles/auth.css';

/**
 * Statyczna Polityka Prywatności – Platforma Egzaminowania Elektronicznego
 * Uzupełnij pola w nawiasach kwadratowych: [ ... ]
 */

export default function PrivacyPolicy() {
    return (
        <div className="auth-container">
            <div className="auth-card" style={{ maxWidth: 980 }}>
                <h1 style={{ marginBottom: 6 }}>Polityka prywatności – Platforma Egzaminowania Elektronicznego</h1>
                <p style={{ marginTop: 0, opacity: 0.9 }}>
                    <strong>Obowiązuje od:</strong> 20.10.2025 r. &nbsp;|&nbsp; <strong>Wersja:</strong> 1.0
                </p>

                <hr style={{ opacity: 0.2 }} />

                <h2>1. Administrator danych</h2>
                <p>
                    Administratorem Twoich danych osobowych jest <strong>Gdańska Akademia Medyczna Nauk Stosowanych</strong> z siedzibą przy{' '}
                    <strong>Pelplińska 7, 80-335 Gdańsk</strong> (dalej: „Uczelnia”).
                </p>
                <p>
                    <strong>Kontakt do Uczelni:</strong> tel. 58 769 08 00
                    <br />
                    <strong>Inspektor Ochrony Danych:</strong> email: administratordanych@wsz.pl
                </p>

                <h2>2. Podmiot przetwarzający</h2>
                <p>
                    Uczelnia korzysta z usług <strong>SoftWro </strong> jako podmiotu przetwarzającego w rozumieniu art. 28 RODO – SoftWro utrzymuje i
                    rozwija Platformę Egzaminowania Elektronicznego na podstawie umowy powierzenia przetwarzania danych.
                </p>

                <h2>3. Zakres przetwarzanych danych</h2>
                <p>W zależności od etapu i formy egzaminu (online/stacjonarnie) przetwarzamy następujące kategorie danych:</p>
                <ul>
                    <li>
                        <strong>Dane identyfikacyjne i kontaktowe:</strong> imię, nazwisko, numer albumu/ID studenta, adres e-mail, oraz inne dane wymagane
                        regulaminem toku studiów/egzaminów.
                    </li>
                    <li>
                        <strong>Dane egzaminacyjne:</strong> odpowiedzi, załączniki, wyniki cząstkowe i końcowe, historia podejść, znaczniki czasu.
                    </li>
                    <li>
                        <strong>Dane weryfikacyjne (wizerunek) i dane biometryczne:</strong> zdjęcie referencyjne wykonane przy rejestracji do egzaminów online,
                        zdjęcie wykonywane bezpośrednio przed egzaminem online oraz wynik automatycznego porównania (weryfikacja 1:1).
                    </li>
                    <li>
                        <strong>Proctoring (nadzór egzaminu online):</strong> nagranie obrazu z kamery podczas egzaminu online oraz oznaczenia („flagi”) momentów
                        potencjalnych naruszeń i metadane techniczne sesji.
                    </li>
                    <li>
                        <strong>Dane techniczne i bezpieczeństwa:</strong> logi systemowe, identyfikatory sesji, adres IP, informacje o przeglądarce/urządzeniu,
                        zdarzenia bezpieczeństwa.
                    </li>
                </ul>
                <p style={{ opacity: 0.9 }}>
                    <strong>Informacja o biometrii:</strong> Automatyczne porównywanie wizerunku twarzy w celu jednoznacznej weryfikacji tożsamości stanowi
                    przetwarzanie danych biometrycznych.
                </p>

                <h2>4. Cele i podstawy prawne przetwarzania</h2>

                <h3>4.1. Przeprowadzenie egzaminów i obsługa procesu dydaktycznego</h3>
                <p>
                    Przetwarzamy dane w celu organizacji i przeprowadzenia egzaminów, obsługi podejść, oceny oraz udostępnienia wyników, a także rozpatrywania
                    odwołań i wyjaśnień.
                    <br />
                    <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. <strong>b</strong> RODO (wykonanie umowy/świadczenie usług edukacyjnych) oraz – w razie
                    potrzeby – art. 6 ust. 1 lit. <strong>f</strong> RODO (prawnie uzasadniony interes Uczelni).
                </p>

                <h3>4.2. Biometryczna weryfikacja tożsamości przed egzaminem online (porównanie twarzy 1:1)</h3>
                <p>
                    W celu potwierdzenia tożsamości osoby przystępującej do egzaminu online Platforma wykonuje zdjęcie twarzy bezpośrednio przed rozpoczęciem egzaminu
                    i porównuje je automatycznie ze zdjęciem referencyjnym wykonanym przy rejestracji.
                    <br />
                    <strong>Podstawa prawna (dane biometryczne):</strong> art. 9 ust. 2 lit. <strong>a</strong> RODO – <strong>wyraźna zgoda</strong>.
                </p>
                <p>
                    <strong>Alternatywa:</strong> brak zgody na biometryczną weryfikację online nie pozbawia prawa do przystąpienia do egzaminu – w takim przypadku
                    możliwe jest zdawanie egzaminu w formie <strong>stacjonarnej w siedzibie Uczelni</strong>.
                </p>

                <h3>4.3. Proctoring – nadzór podczas egzaminu online</h3>
                <p>
                    Podczas egzaminu online przetwarzamy obraz z kamery w celu weryfikacji rzetelności przebiegu egzaminu i przeciwdziałania nadużyciom, w tym
                    oznaczamy momenty potencjalnych naruszeń („flagi”), aby umożliwić ich weryfikację po egzaminie.
                    <br />
                    <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. <strong>f</strong> RODO (prawnie uzasadniony interes Uczelni polegający na zapewnieniu
                    integralności i uczciwości egzaminów) oraz – w zakresie organizacji egzaminu online – art. 6 ust. 1 lit. <strong>b</strong> RODO.
                </p>

                <h3>4.4. Bezpieczeństwo, rozliczalność i wsparcie techniczne</h3>
                <p>
                    Prowadzimy działania zapewniające bezpieczeństwo Platformy (logi, monitoring, kopie zapasowe, obsługa incydentów, wsparcie techniczne).
                    <br />
                    <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. <strong>f</strong> RODO (prawnie uzasadniony interes Uczelni).
                </p>

                <h2>5. Zautomatyzowane przetwarzanie i udział człowieka</h2>
                <p>
                    Platforma stosuje elementy automatycznej analizy, w szczególności: (1) automatyczne porównanie zdjęć twarzy (weryfikacja 1:1) przed egzaminem
                    online oraz (2) automatyczne oznaczanie („flagi”) momentów potencjalnych naruszeń w nagraniu z kamery.
                </p>
                <p>
                    <strong>
                        Wynik egzaminu oraz rozstrzygnięcia dotyczące naruszeń nie są podejmowane wyłącznie w sposób zautomatyzowany
                    </strong>
                    . Materiał proctoringowy i oznaczenia są analizowane przez człowieka (prowadzącego/komisję), zgodnie z procedurami Uczelni.
                </p>

                <h2>6. Odbiorcy danych i dostęp</h2>
                <p>Twoje dane mogą być udostępniane wyłącznie w zakresie niezbędnym do realizacji celów przetwarzania:</p>
                <ul>
                    <li>
                        <strong>Prowadzący</strong> – w zakresie danych egzaminacyjnych oraz materiału proctoringowego/„flag” (weryfikacja rzetelności przebiegu
                        egzaminu); w razie negatywnej weryfikacji tożsamości – dostęp do dwóch zdjęć (referencyjnego i wykonanego przed egzaminem) w celu ręcznej analizy.
                    </li>
                    <li>
                        <strong>Administrator (admin)</strong> – w zakresie niezbędnym do utrzymania i bezpieczeństwa Platformy.
                    </li>
                    <li>
                        <strong>SoftWro</strong> – jako podmiot przetwarzający (art. 28 RODO), w zakresie utrzymania i rozwoju systemu.
                    </li>
                    <li>
                        <strong>Dostawcy infrastruktury (podprocesorzy)</strong> – w zakresie hostingu i usług technicznych (np. AWS, TheCamels) na podstawie dalszego
                        powierzenia, z odpowiednimi zabezpieczeniami.
                    </li>
                    <li>
                        <strong>Organy publiczne</strong> – wyłącznie, jeśli obowiązek udostępnienia wynika z przepisów prawa.
                    </li>
                </ul>
                <p style={{ opacity: 0.9 }}>
                    Dostęp do materiału wizerunkowego (zdjęcia przy negatywnej weryfikacji) oraz nagrań proctoringowych mają wyłącznie <strong>prowadzący</strong> i{' '}
                    <strong>admin</strong>.
                </p>

                <h2>7. Miejsce przetwarzania danych i transfery poza EOG</h2>
                <p>
                    Dane są przechowywane i przetwarzane z wykorzystaniem infrastruktury hostingowej (w tym <strong>AWS</strong> oraz <strong>TheCamels</strong>) w
                    lokalizacjach na terenie UE/EOG.
                </p>
                <p>
                    Jeżeli wyjątkowo doszłoby do przekazania danych poza EOG, nastąpi to wyłącznie przy zastosowaniu mechanizmów zgodnych z RODO (np. standardowe
                    klauzule umowne) i adekwatnych zabezpieczeń.
                </p>

                <h2>8. Okres przechowywania danych (retencja)</h2>

                <h3>8.1. Zdjęcia do weryfikacji tożsamości</h3>
                <ul>
                    <li>
                        Zdjęcie wykonywane bezpośrednio przed egzaminem online <strong>nie jest utrwalane</strong> w przypadku pozytywnej weryfikacji i jest usuwane
                        niezwłocznie po zakończeniu procesu porównania.
                    </li>
                    <li>
                        W przypadku negatywnej weryfikacji zdjęcie przed egzaminem może zostać zapisane oraz udostępnione prowadzącemu wraz ze zdjęciem referencyjnym w
                        celu ręcznej analizy; takie zdjęcie jest przechowywane przez <strong>30 dni</strong>.
                    </li>
                    <li>
                        Zdjęcie referencyjne (rejestracyjne) jest przechowywane przez okres obowiązywania zgody na biometryczną weryfikację online lub do jej wycofania,
                        a następnie usuwane w terminie do <strong>30 dni</strong> od skutecznego wycofania zgody (o ile dalsze przechowywanie nie jest niezbędne z uwagi na
                        toczące się postępowanie/odwołanie).
                    </li>
                </ul>

                <h3>8.2. Nagranie z kamery (proctoring) i „flagi”</h3>
                <p>
                    Nagranie obrazu z kamery podczas egzaminu online oraz oznaczenia („flagi”) są przechowywane przez <strong>30 dni</strong> od daty egzaminu.
                </p>

                <h3>8.3. Dane egzaminacyjne i techniczne</h3>
                <ul>
                    <li>
                        Dane egzaminacyjne (odpowiedzi, wyniki, historia podejść) przechowujemy przez okres niezbędny do realizacji procesu dydaktycznego i rozpatrywania
                        odwołań: <strong>12 miesięcy</strong>.
                    </li>
                    <li>
                        Logi techniczne i bezpieczeństwa przechowujemy przez <strong>90 dni</strong>, chyba że dłuższe przechowywanie jest konieczne do wyjaśnienia
                        incydentu.
                    </li>
                </ul>
                <p>
                    Po upływie okresów retencji dane są usuwane lub anonimizowane, o ile przepisy prawa nie wymagają dłuższego przechowywania.
                </p>

                <h2>9. Bezpieczeństwo danych</h2>
                <p>Stosujemy środki techniczne i organizacyjne adekwatne do ryzyka, w szczególności:</p>
                <ul>
                    <li>szyfrowanie transmisji (TLS/HTTPS) oraz zabezpieczenia danych w infrastrukturze hostingowej,</li>
                    <li>szyfrowanie plików na serwerach,</li>
                    <li>kontrolę dostępu i role (zasada najmniejszych uprawnień),</li>
                    <li>rejestrowanie dostępu i zdarzeń (logi),</li>
                    <li>kopie zapasowe oraz procedury odtwarzania,</li>
                    <li>ograniczenie dostępu do materiałów proctoringowych i zdjęć wyłącznie do prowadzącego i admina.</li>
                </ul>

                <h2>10. Twoje prawa</h2>
                <p>
                    Przysługują Ci prawa wynikające z RODO, w szczególności: prawo dostępu do danych, sprostowania, usunięcia (w granicach prawa), ograniczenia
                    przetwarzania, przenoszenia danych (gdy spełnione są przesłanki), a także prawo sprzeciwu wobec przetwarzania opartego o art. 6 ust. 1 lit. f RODO.
                </p>
                <p>
                    Jeśli przetwarzanie odbywa się na podstawie zgody (biometryczna weryfikacja tożsamości), masz prawo{' '}
                    <strong>wycofać zgodę w dowolnym momencie</strong> – bez wpływu na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem.
                </p>

                <h3>10.1. Wycofanie zgody – tryb mailowy</h3>
                <p>
                    Wycofanie zgody na biometryczną weryfikację tożsamości następuje poprzez wysłanie wiadomości e-mail na adres:{' '}
                    <strong>pomoc@softwro.pl</strong>, z informacją pozwalającą na identyfikację w systemie (np. imię i nazwisko, numer albumu/ID
                    studenta, e-mail w Platformie). Uczelnia potwierdzi przyjęcie zgłoszenia oraz przekaże informacje o dalszej procedurze przystąpienia do egzaminu
                    (forma stacjonarna).
                </p>
                <p>
                    Masz również prawo wnieść skargę do <strong>Prezesa Urzędu Ochrony Danych Osobowych (UODO)</strong>.
                </p>

                <h2>11. Czy podanie danych jest obowiązkowe?</h2>
                <p>
                    Podanie danych niezbędnych do realizacji egzaminu (np. identyfikacyjnych i egzaminacyjnych) jest konieczne do przeprowadzenia egzaminu w danej
                    formie.
                </p>
                <p>
                    Podanie danych biometrycznych (automatyczne porównanie twarzy) jest <strong>dobrowolne</strong>. Brak zgody oznacza brak możliwości skorzystania z
                    tej metody weryfikacji w trybie online – możesz przystąpić do egzaminu <strong>stacjonarnie</strong> w siedzibie Uczelni.
                </p>

                <h2>12. Pliki cookies</h2>
                <p>
                    Platforma wykorzystuje przede wszystkim niezbędne pliki cookies (sesyjne) służące do uwierzytelniania i bezpieczeństwa. Dodatkowe cookies (np.
                    analityczne) mogą być stosowane wyłącznie, jeśli zostaną wdrożone i – gdy wymagane – po uzyskaniu zgody użytkownika.
                </p>

                <h2>13. Zmiany polityki</h2>
                <p>
                    Polityka może być aktualizowana, jeżeli wymaga tego prawo lub zmienia się sposób działania Platformy. Aktualna wersja jest dostępna w Platformie i
                    pod adresem: <strong>egazamin.wsz.pl/polityka-prywatnosci</strong>.
                </p>
            </div>
        </div>
    );
}
